import { nativeSrpPayload } from '~/native/home/utils';
import { SuggestedSearch } from './useGetSuggestedSearches';

type OwnProps = {
  links: SuggestedSearch[];
};

export default function SuggestedLinks({ links }: OwnProps) {
  return (
    <div
      className="flex h-full flex-wrap items-center justify-start gap-md overflow-scroll m:max-h-[354px]"
      data-qa="suggested-search-links"
    >
      {links.map(({ Icon, title, link }) => (
        <a
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: 'Search Card',
            type: 'suggested',
            item: 'search'
          })}
          data-native-payload={nativeSrpPayload}
          key={title}
          href={link}
          className="flex items-center gap-md rounded-[6px] border border-grey-2 bg-white p-sm px-lg py-[10px] text-blue-6"
        >
          {Icon ? Icon : null}
          <p className="tl-body-s">{title}</p>
        </a>
      ))}
    </div>
  );
}
